import React from "react";
import { cva } from "class-variance-authority";
import Util from '../../Util';

const badgeVariants = cva(
  "font-bold whitespace-nowrap inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover-elevate",
  {
    variants: {
      status: {
        1: "text-blue-700 dark:text-blue-400 bg-blue-100/50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800",
        2: "text-amber-700 dark:text-amber-400 bg-amber-100/50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800",
        3: "text-emerald-700 dark:text-emerald-400 bg-emerald-100/50 dark:bg-emerald-900/20 border-emerald-200 dark:border-emerald-800",
        4: "text-red-700 dark:text-red-400 bg-red-100/50 dark:bg-red-900/20 border-red-200 dark:border-red-800",
        5: "text-purple-700 dark:text-purple-400 bg-purple-100/50 dark:bg-purple-900/20 border-purple-200 dark:border-purple-800",
        6: "text-slate-700 dark:text-slate-400 bg-slate-100/50 dark:bg-slate-900/20 border-slate-200 dark:border-slate-800",
      },
    },
    defaultVariants: {
      status: 1,
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div
      className={className}
      {...props}
    />
  );
}

export { Badge, badgeVariants };